import { Sender } from 'xstate';

import config from '@/config';
import asyncCallback from '@/framework/logic/utils/asyncCallback';
import LivePersonChatFrontend from '@/ports-frontend/LivePersonChat';

export const watchLivePersonChatAction = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'CASHIER_LIVE_CHAT_OPEN';
      }>
    ) => {
      const livePersonChatConfig = config.features.livePersonChatListener;
      if (
        livePersonChatConfig?.mode === 'disabled' ||
        !livePersonChatConfig?.redirectUrl ||
        !livePersonChatConfig?.name
      ) {
        return;
      }
      const subscriptions: Function[] = [];
      subscriptions.push(
        await LivePersonChatFrontend.onOpenCashierLiveChat(() => {
          callback({
            type: 'CASHIER_LIVE_CHAT_OPEN',
          });
        })
      );
      return () => {
        subscriptions.forEach(unsub => unsub());
      };
    }
  );
